import { useContext } from "react";
import EventContext from "../store/event-context";
import appTheme from '../appTheme';
import { ThemeProvider } from '@mui/material/styles'
import { Box, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';

const ColorSelection = ({ color, setColor, fieldWidth }) => {
    const handleChange = (event) => {
        console.log(event.target.value)
        setColor(event.target.value);
    };

    // The file events.json contains for every event the colors property.
    //    - "colors": ["blue","orange"]
    // or - "colors": ["blue"]
    // This property is available from the eventService.
    //
    const eventctx = useContext(EventContext);
    //console.log("Event: ", eventctx.event);
    if (eventctx.event.colors && eventctx.event.colors.length === 1) {
        setColor(eventctx.event.colors[0]);
    }

    const renderValue = (value) => {
        const bckcolor = 'capColorBackground.' + value;     // backgroud differs per color-value - picked from theme
        const textcolor = 'capColorText.' + value;          // text color differs per color-value - picked from theme
        return (
            <Typography sx={{backgroundColor: bckcolor, color: textcolor, paddingLeft: '6px'}}>
                {value}
            </Typography>
        )
    }

    const menuWidth = fieldWidth - 20;
    

    if (eventctx.event.colors.length > 1) {
        //console.log("More colors - So choose..");
        return (
        <ThemeProvider theme={appTheme}>
        <Box component='span' id="ColorSelection">
            <FormControl required sx={{width: fieldWidth+'px', mr: 1}}>
                <InputLabel id="ColorSelect">Kleur</InputLabel>
                <Select
                    labelId="ColorSelectLabel"
                    id="colorSelectId"
                    value={color}
                    onChange={handleChange}
                    label="Kleur"
                    renderValue={renderValue}
                    MenuProps={{
                        sx: {
                        "&& .Mui-selected": {
                            backgroundColor: "capColorBackground." + color,
                            color: "capColorText." + color }
                        }
                    }}
                >
                {eventctx.event.colors.map((item) => 
                    <MenuItem key={item} 
                        divider
                        value={item} 
                        sx={{backgroundColor: 'capColorBackground.' + item, 
                            color: 'capColorText.' + item, 
                            paddingLeft: '6px',
                            marginLeft: '12px',
                            width: menuWidth+'px'}}>
                    {item}
                    </MenuItem>
                )}
                </Select>
            </FormControl>
        </Box>
        </ThemeProvider>)
    } else {
        //console.log("Colors?: ", eventctx.event.colors.length );
        return null;
    }
}

export default ColorSelection
